import React from "react"
import types from "prop-types"
import { dynamicRangeTasksExample, weekRangeTaskInclusionDescription } from "utils/scheduledReportExportHelpers"

const WeeksTaskDateDescription = ({ dateFilterType, startDate, taskPreviousRangeLength = null }) => {
  const weekCount = taskPreviousRangeLength || 1

  const beginningWeek = startDate.subtract(weekCount, "w")
  const beginningDate = beginningWeek.weekday(0)

  // endingDate is n weeks from start date minus one day
  const endingDate = beginningDate.add(weekCount, "w").subtract(1, "d")

  return (
    <div className="text-xs text-dark mt-2">
      <p className="mb-4">
        {weekRangeTaskInclusionDescription(dateFilterType)}
      </p>
      <p>
        {dynamicRangeTasksExample({
          startDate, beginningDate, endingDate, dateFilterType,
        })}
      </p>
    </div>
  )
}

WeeksTaskDateDescription.propTypes = {
  dateFilterType: types.string.isRequired,
  startDate: types.object.isRequired,
  taskPreviousRangeLength: types.number,
}

export default WeeksTaskDateDescription
